import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "page-info" }

import { ref } from 'vue'
import AdminMenu from 'components/admin/admin-menu.vue'
import AdminHeader from 'components/admin/admin-header.vue'
import AdminTagList from 'components/admin/admin-tag-list.vue'
import { useStore } from '@/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'admin-main',
  setup(__props) {

const isCollapse = ref(false)
const store = useStore()
store.commit('changeCollapse', isCollapse.value)
const handleFoldChange = (isFold: boolean) => {
  isCollapse.value = isFold
  store.commit('changeCollapse', isCollapse.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "main-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          width: isCollapse.value ? '60px' : '210px'
        }, {
          default: _withCtx(() => [
            _createVNode(AdminMenu, { collapse: isCollapse.value }, null, 8, ["collapse"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_container, { class: "page" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { class: "page-header" }, {
              default: _withCtx(() => [
                _createVNode(AdminHeader, { onFoldChange: handleFoldChange })
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { class: "page-content" }, {
              default: _withCtx(() => [
                _createVNode(AdminTagList),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_router_view, null, {
                    default: _withCtx(({ Component }) => [
                      _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                          Component
                            ? (_openBlock(), _createBlock(_KeepAlive, {
                                key: 0,
                                max: 10
                              }, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                              ], 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})